import './src/assets/sass/main.scss';
import './src/styles/global.scss';

// Scroll to the top of the page on every route change
export const onRouteUpdate = () => {
  window.scrollTo(0, 0);

  if (localStorage.getItem('trackingconsent_status') === 'allow' && typeof window !== 'undefined' && window._paq) {
    const params = new URLSearchParams(location.search);
    const refParam = params.get("ref");

    if (refParam) {
      window._paq.push(["setCustomDimension", 1, refParam]);
    }

    // Optional: Tracking der Seitenansicht erneut triggern (wenn nötig)
    window._paq.push(["setCustomUrl", location.href]);
    window._paq.push(["trackPageView"]);
  }
};
